/**
 * User type definitions
 */

// Role types for role-based access control
export type UserRole = 'user' | 'moderator' | 'admin';

// Membership status types
export type MembershipStatus = 'pending' | 'active' | 'suspended' | 'inactive';

// Gender options
export type GenderOption = 
  | 'Man'
  | 'Woman'
  | 'Agender'
  | 'Androgynous'
  | 'Bigender'
  | 'Gender Fluid'
  | 'Gender Nonconforming'
  | 'Genderqueer'
  | 'Gender questioning'
  | 'Intersex'
  | 'Non-binary'
  | 'Other'
  | 'Pangender'
  | 'Transfeminine'
  | 'Transmasculine'
  | 'Trans person'
  | 'Trans Man'
  | 'Trans Non-binary'
  | 'Trans Woman'
  | 'Two-Spirit';

// Sexuality options
export type SexualityOption =
  | 'Straight'
  | 'Androgynosexual'
  | 'Androsexual'
  | 'Asexual'
  | 'Autosexual'
  | 'Bisexual'
  | 'Bi-curious'
  | 'Demisexual'
  | 'Gay'
  | 'GrayA'
  | 'Gynosexual'
  | 'Heteroflexible'
  | 'Homoflexible'
  | 'Lesbian'
  | 'Objectumsexual'
  | 'Omnisexual'
  | 'Pansexual'
  | 'Polysexual'
  | 'Queer'
  | 'Skoliosexual'
  | 'Heterosexual'
  | 'Questioning'
  | 'Other';


// User profile interface
export interface UserProfile {
  uid: string;
  email: string;
  username: string; // Unique public username - mandatory for all users
  
  // Private information (admin-only access)
  firstName?: string; // Real first name - private
  lastName?: string; // Real last name - private, optional
  
  // Public information
  displayName?: string; // Legacy field for Firebase Auth compatibility
  photoURL?: string;
  introduction?: string; // Max 500 characters
  consentUnderstanding?: string; // Understanding of consent for auto-filling event applications
  photoUrls?: string[]; // Max 5 photos
  profilePictureUrl?: string;
  interests?: string[];
  gender?: GenderOption;
  genderOther?: string; // Used when gender is "Other"
  sexuality?: SexualityOption;
  sexualityOther?: string; // Used when sexuality is "Other"
  birthDate?: string; // ISO format date string
  role: UserRole;
  membershipStatus: MembershipStatus;
  createdAt: number;
  updatedAt: number;
}

// Username validation options
export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 20;
export const USERNAME_REGEX = /^[a-zA-Z0-9_]+$/; // Alphanumeric and underscores only

// List of reserved usernames that cannot be chosen
export const RESERVED_USERNAMES = [
  'admin',
  'administrator',
  'bodysharing',
  'support',
  'help',
  'moderator',
  'mod',
  'system',
  'official',
  'staff',
  'team',
  'info',
  'contact',
  'account',
  'user',
  'username',
  'profile',
  'signin',
  'signup',
  'login',
  'logout',
  'root'
];
